// extracted by mini-css-extract-plugin
export default {"kitoButton":"styles_kitoButton__+Q2fa"};